// Service Worker registration and update management
// Handles automatic reloading on new versions

let registration: ServiceWorkerRegistration | null = null;

export async function registerServiceWorker() {
  // DOČASNE VYPNUTÉ - Service Worker blokuje PATCH requesty
  console.log('[SW] Service Worker registration DISABLED for debugging');
  return;
  
  if ('serviceWorker' in navigator) {
    try {
      // Clear all existing caches first
      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames.map(cacheName => {
            console.log('[SW] Deleting cache:', cacheName);
            return caches.delete(cacheName);
          })
        );
      }
      
      // Check for existing service workers but don't unregister them
      const existingRegistrations = await navigator.serviceWorker.getRegistrations();
      if (existingRegistrations.length > 0) {
        console.log('[SW] Found existing service workers:', existingRegistrations.length);
        // Only unregister if they're from different scope
        for (let reg of existingRegistrations) {
          if (reg.scope !== self.location.origin + '/') {
            console.log('[SW] Unregistering service worker from different scope:', reg.scope);
            await reg.unregister();
          }
        }
      }
      
      // Register service worker with cache busting
      const cacheBuster = Date.now();
      registration = await navigator.serviceWorker.register(`/sw.js?cb=${cacheBuster}`, {
        updateViaCache: 'none'
      });
      
      console.log('[SW] Service Worker registered successfully:', registration.scope);
      
      // Check for updates immediately
      await checkForUpdates();
      
      // Set up automatic update checking
      setupUpdateFlow();
      
    } catch (error) {
      console.error('[SW] Service Worker registration failed:', error);
    }
  }
}

export async function checkForUpdates() {
  if (registration) {
    try {
      await registration.update();
      console.log('[SW] Update check completed');
    } catch (error) {
      console.error('[SW] Update check failed:', error);
    }
  }
}

function setupUpdateFlow() {
  if (!registration) return;
  
  // Listen for new service worker waiting
  registration.addEventListener('updatefound', () => {
    const newWorker = registration!.installing;
    
    if (newWorker) {
      console.log('[SW] New service worker found, installing...');
      
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          console.log('[SW] New service worker installed, ready for activation');
          
          // Show update notification instead of forcing reload
          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.addEventListener('controllerchange', () => {
              console.log('[SW] New service worker is now controlling the page');
              // Optionally reload here if needed
            });
          }
        }
      });
    }
  });
  
  // Listen for service worker controlling the page
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('[SW] New service worker is now controlling the page');
    // Don't force reload - let user decide
  });
  
  // Listen for messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'CACHE_UPDATED') {
      console.log('[SW] Cache updated, ready for use');
      // Don't force reload - let user decide
    }
  });
}

// Unregister service worker (for debugging)
export async function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (let registration of registrations) {
        await registration.unregister();
        console.log('[SW] Service Worker unregistered');
      }
    } catch (error) {
      console.error('[SW] Service Worker unregistration failed:', error);
    }
  }
}

// Get current service worker status
export function getServiceWorkerStatus() {
  if (!('serviceWorker' in navigator)) {
    return { supported: false };
  }
  
  return {
    supported: true,
    controller: navigator.serviceWorker.controller?.scriptURL,
    registration: registration?.active?.scriptURL,
    state: registration?.active?.state
  };
}